import { render, staticRenderFns } from "./MyShop.vue?vue&type=template&id=6ba016b4&"
import script from "./MyShop.vue?vue&type=script&lang=js&"
export * from "./MyShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports